import React from "react";
import { motion } from "framer-motion";
import { Col, Button } from "react-bootstrap";

import InvoiceCard from "../../components/InvoiceCard";
import InvoiceChart from "../../components/InvoiceChart";
import InvoiceTable from "../../components/InvoiceTable";

import {
  FaFileInvoice,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaDollarSign,
} from "react-icons/fa";

function InvoiceReport() {

  const stats = [
    {
      title: "Total Invoices",
      value: 600,
      icon: FaFileInvoice,
    },
    {
      title: "Paid Invoices",
      value: 450,
      icon: FaCheckCircle,
    },
    {
      title: "Unpaid Invoices",
      value: 150,
      icon: FaTimesCircle,
    },
    {
      title: "Overdue Invoice",
      value: 80,
      icon: FaClock,
    },
    {
      title: "Partially Paid",
      value: 80,
      icon: FaClock,
    },
    {
      title: "Revenue",
      value: "$25,340",
      icon: FaDollarSign,
    },
  ];

  const chartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Total Invoices",
        data: [50000, 60000, 40000, 70000, 50000, 75000],
        borderColor: "#3b82f6",
        backgroundColor: "transparent",
      },
      {
        label: "Paid Invoices",
        data: [30000, 40000, 20000, 50000, 30000, 55000],
        borderColor: "#ef4444",
        backgroundColor: "transparent",
      },
    ],
  };

  return (
    <div className="container-fluid mt-3" style={{marginLeft:"18px"}}>

      {/* HEADER */}
      <div className="d-flex align-items-center mb-3">
        <h4 className="mb-0">Invoice Report</h4>
        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      {/* CARDS + CHART */}
      <motion.div className="row g-3 mb-3">

        {/* LEFT SIDE (CARDS) */}
        <Col md={5}>
          <InvoiceCard stats={stats} />
        </Col>

        {/* RIGHT SIDE (CHART) */}
        <Col md={7}>
          <InvoiceChart chartData={chartData} />
        </Col>

      </motion.div>

      {/* TABLE */}
      <InvoiceTable />

    </div>
  );
}

export default InvoiceReport;